import Font from '~/data/records/Font';

export default function deserializeFonts(fonts) {
  return fonts.map(cat => new Font(cat));
}
